import { useEffect, useRef } from "react";

export function useBackToCloseModal(
  open: boolean,
  onClose: () => void,
  key = "qr-modal",
) {
  const pushedRef = useRef(false);
  const closingByBackRef = useRef(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const onPopState = (e: PopStateEvent) => {
      if (!open) return;

      // Đây là pop do ta tự gọi history.back() khi đóng modal → bỏ qua
      closingByBackRef.current = true;
      pushedRef.current = false;
      onClose();
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [open, onClose]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (open && !pushedRef.current) {
      // Mở modal: đẩy 1 entry mới với URL hiện tại
      window.history.pushState({ __modal: key }, "", undefined as any);
      pushedRef.current = true;
    }

    if (!open && pushedRef.current) {
      // Đóng bằng nút "Đóng" → quay lại 1 bước để pop entry modal
      closingByBackRef.current = true;
      window.history.back();
      pushedRef.current = false;
    }
  }, [open, key]);

  // Nếu unmount khi modal còn mở → dọn stack
  useEffect(() => {
    return () => {
      if (pushedRef.current) {
        window.history.back();
        pushedRef.current = false;
      }
    };
  }, []);
}
